export const getMediumLatestFeeds = async () => {
  const response = await fetch(
    'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@admin_45348',
  );
  const body = await response.json();
  return body;
};
